import {
    analyticsCardRejectedClickDashboardFooter,
    analyticsCardRejectedClickShop,
} from '@perpay-web/fintech/actions/analytics/cardOnboardingMVP2';
import {
    analyticsCKPartnerHostedOnboardingRejectionScreen,
    analyticsCKPartnerHostedOnboardingApplicationRejectedClickDashboard,
    analyticsNonCKPartnerHostedOnboardingRejectionScreen,
    analyticsNonCKPartnerHostedOnboardingApplicationRejectedClickDashboard,
} from '@perpay-web/fintech/actions/analytics/partnerHostedOnboarding';
import CardRejectionSwitcher from '@perpay-web/fintech/components/composite/CardRejectionSwitcher/CardRejectionSwitcher';
import {
    CREDIT_KARMA_INVITE_TO_APPLY,
    CREDIT_KARMA_LIGHTBOX,
} from '@perpay-web/fintech/constants/partnerOnboardingCodes';
import {
    getPassedIdv,
    fetchCardAccountApplicationDataModule,
} from '@perpay-web/fintech/dataModules/fetchCardAccountApplications';
import { getMarketplaceSpendingLimit } from '@perpay-web/fintech/dataModules/fetchCardAccountApplications';
import { useAppDispatch, useAppSelector } from '@perpay-web/fintech/hooks';
import { noop } from '@perpay-web/utils/noop';

type CardRejectionSwitcherContainerProps = {
    partnerCode: string;
};

const CardRejectionSwitcherContainer = ({
    partnerCode,
}: CardRejectionSwitcherContainerProps) => {
    const dispatch = useAppDispatch();
    const passedKyc = useAppSelector(getPassedIdv);
    const isLoadingOrUnrequested = useAppSelector(
        fetchCardAccountApplicationDataModule.getIsLoadingOrUnrequested,
    );
    const marketplaceSpendingLimit = useAppSelector(
        getMarketplaceSpendingLimit,
    );

    const onClickDashboardStandard = () => {
        dispatch(analyticsCardRejectedClickDashboardFooter());
    };
    const onMountCreditKarma = () => {
        dispatch(analyticsCKPartnerHostedOnboardingRejectionScreen());
    };
    const onMountNonCreditKarma = () => {
        dispatch(analyticsNonCKPartnerHostedOnboardingRejectionScreen());
    };

    const onClickShop = () => {
        dispatch(analyticsCardRejectedClickShop());
    };
    const onClickDashboardCreditKarma = () => {
        dispatch(
            analyticsCKPartnerHostedOnboardingApplicationRejectedClickDashboard(),
        );
    };
    const onClickDashboardNonCreditKarma = () => {
        dispatch(
            analyticsNonCKPartnerHostedOnboardingApplicationRejectedClickDashboard(),
        );
    };

    const isPHO = Boolean(partnerCode);
    const isCreditKarmaPartner =
        partnerCode === CREDIT_KARMA_LIGHTBOX ||
        partnerCode === CREDIT_KARMA_INVITE_TO_APPLY;

    let onMount = noop;
    if (isCreditKarmaPartner) {
        onMount = onMountCreditKarma;
    } else if (isPHO) {
        onMount = onMountNonCreditKarma;
    }

    let onClickDashboard = onClickDashboardStandard;
    if (isCreditKarmaPartner) {
        onClickDashboard = onClickDashboardCreditKarma;
    } else if (isPHO) {
        onClickDashboard = onClickDashboardNonCreditKarma;
    }

    return (
        <CardRejectionSwitcher
            isLoading={Boolean(isLoadingOrUnrequested)}
            passedKyc={passedKyc}
            isPHO={isPHO}
            isCreditKarmaPartner={isCreditKarmaPartner}
            marketplaceSpendingLimit={marketplaceSpendingLimit}
            onMount={onMount}
            onClickDashboard={onClickDashboard}
            onClickShop={onClickShop}
        />
    );
};

export default CardRejectionSwitcherContainer;
